import { createFormContext } from '@myphx-engineering/phx-design-system/hooks';

export type VerifyFormDetails = {
    firstName: string;
    lastName: string;
    dobMonth: string;
    dobDay: string;
    dobYear: string;
    attest: boolean;
};

export const [VerifyFormProvider, useVerifyFormContext, useVerifyForm] =
    createFormContext<VerifyFormDetails>();
